import React, { useState } from 'react';
import 'firebase/database';
import { createUserWithEmailAndPassword } from "firebase/auth"
import { auth, fbRtDb } from '../../firebase-config';
import './signup.css'
import { NavLink } from 'react-router-dom'
import { set, ref } from 'firebase/database';
import Button from '../Shared/Button';
import { addUser } from '../../Datahandler';

const SignUp = () => {
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    business: '',
    name: '',
    email: '',
    title: '',
    password: '',
    cpassword: '',
  });
  const [emailError, setEmailError] = useState('');
  const [email, setEmail] = useState('');

  const handleInputChange = (event) => {
    if (event.target.name === 'email') {
      setEmailError('');
      setEmail(event.target.value);
    }
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    createUserWithEmailAndPassword(auth, formData.email, formData.password)
      .then((userCredential) => {
        // Signed in 
        var user = userCredential.user;
        alert(`Great - you have been added as: ` + formData.name)

        addUser(`${formData.name} ${formData.surname}`, formData.email, formData.title, null, null, formData.business)
      })
      .catch((error) => {
        console.error('createUserWithEmailAndPassword error:', error);
      });
  };



  return (

    <div>

      <div className="centered-container">
        <div className="loginDiv">
          <h1 className="loginTitle"> Sign up </h1>
          <p className="loginSubtitle">Glad you decided to join us! Fill in the following form <br /> and press Sign up when you’re done.</p>
          <form onSubmit={handleSubmit} className="signup-container">
            <div className="input-row">
              <div className="signup-label">
                <label className='emailLabel' htmlFor="name" >Name:</label>
                <input
                  className='signUpInput'
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </div>
              <div className="signup-label">
                <label className='emailLabel' htmlFor="surname" >Surname:</label>
                <input
                  className='signUpInput'
                  type="text"
                  id="surname"
                  name="surname"
                  value={formData.surname}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="input-row">
              <div className="signup-label">
                <label className='emailLabel' htmlFor="business">Business Unit:</label>
                <input
                  className='signUpInput'
                  type="text"
                  id="business"
                  name="business"
                  value={formData.business}
                  onChange={handleInputChange}
                />
              </div>
              <div className="signup-label">
                <label className='emailLabel' htmlFor="title">Job Title:</label>
                <input
                  className='signUpInput'
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="signup-label">
              <label className='emailLabel' htmlFor="email">Email:</label>
              <input
                className="loginInput"
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>
            <div className="signup-label">
              <label className='emailLabel' htmlFor="password">Password:</label>
              <input
                className="loginInput"
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
              />
            </div>
            <div className="signup-label">
              <label className='emailLabel' htmlFor="cpassword">Confirm Password:</label>
              <input
                className="loginInput"
                type="password"
                id="cpassword"
                name="cpassword"
                value={formData.cpassword}
                onChange={handleInputChange}
              />
            </div>
            <br />
            <div className="signup-button-container">
              <Button type='sumbit' text='Sign Up' buttonStyle='blue' />
            </div>
          </form>
          <div className="lineDiv"></div>
          <p className="text-sm text-white text-center">
            Have you already registered? {' '}
            <NavLink to="/login">
              Login
            </NavLink>
            {' '}instead
          </p>
        </div>

      </div>
    </div>

  );
};

export default SignUp;
